import React, { useContext } from 'react'
import CalendarEventStatus from '../../../../components/EventStatus/CalendarEventStatus'
import CalendarFacilityContext from '../../../CalendarFacilityProvider'

export default function CalendarEventUpdateEvent({ properties, onChange }) {
  const { calendarEvent, setCalendarEventProperty } = useContext(CalendarFacilityContext)

  const _findProp = (name) => {
    if (!calendarEvent || !calendarEvent.properties) return undefined
    const _val = calendarEvent.properties.find(n => n.name === name)
    return _val ? _val.value : undefined
  }
  const _handleChange = (k, v) =>
    setCalendarEventProperty(k, v)

  return (
    <div>
      <div>
        <label>Change status to</label>
        <CalendarEventStatus
          onChange={(e) => _handleChange('DEFAULT_STATUS_ORIGINAL', e)}
          defaultValue={_findProp('DEFAULT_STATUS_ORIGINAL')} />
        <input
          onChange={(e) => _handleChange('DEFAULT_SUMMARY_ORIGINAL', e.target.value)}
          defaultValue={_findProp('DEFAULT_SUMMARY_ORIGINAL')}
          className='form-control form-control-sm' placeholder='Default Updated Summary' />
        <textarea
          onChange={(e) => _handleChange('DEFAULT_DETAILS_ORIGINAL', e.target.value)}
          defaultValue={_findProp('DEFAULT_DETAILS_ORIGINAL')}
          className='form-control form-control-sm' placeholder='Default updated event details' ></textarea>
      </div>
    </div>
  )
}
